import React from 'react';
import intl from 'react-intl-universal';
import {observer} from 'mobx-react-lite';

import {useAppState} from '@stores/AppStateContext';
import type {ItemModelType} from '@stores/WorkspaceStore';
import {ContextMenu} from '../../../components/ContextMenu/ContextMenu';
import {SettingsIcon} from '../../../components/icons/SettingsIcon';
import {GroupIcon} from '../../../components/icons/GroupIcon';
import {MODALS} from '../../../screens/modals/modal-names';
import {ContextMenuInterface} from '../ContextMenuInterface';

export interface LibraryRowOptionsProps extends ContextMenuInterface {
    library: ItemModelType;
}

export const LibraryRowOptions = observer(({handleClose, isDark, library}: LibraryRowOptionsProps) => {
    const appState = useAppState();

    return (
        <ContextMenu
            isDark={isDark}
            handleClose={handleClose}
            items={[
                {
                    text: intl.get('library.options.settings').d('Settings'),
                    Icon: SettingsIcon,
                    onClick: () => {
                        appState.setContextMenu(null);
                        appState.setModal({name: MODALS.SECTION_EDIT, params: {section: library}});
                    },
                },
                {
                    text: intl.get('library.options.assignRoles').d('Assign Roles'),
                    Icon: GroupIcon,
                    onClick: () => {
                        appState.setContextMenu(null);
                        appState.setModal({
                            name: MODALS.ASSIGN_SECTION_ROLES,
                            params: {
                                sectionId: library.id,
                                sectionName: library.name || intl.get('common.untitled_section').d('Untitled section'),
                            },
                        });
                    },
                },
            ]}
        />
    );
});
